<template>
	<div class="course_group w1200 flex" id="course_group">
		<div class="group_l cl_white" :style="{background:'url(' + groupInfo.bg + ') no-repeat'}">
			<h3 class="f26px">{{groupInfo.title}}</h3>
			<h4>{{groupInfo.titleVice}}</h4>
			<p class="mat10">{{groupInfo.cont}}</p>
			<div class="group_nav mat30">
				<div class="group_nav_list mab10" v-for="(item,index) in groupNav" :key="index" :class="{on:groupCurrent == index}" @click="navCheck(index)">
					<span>{{item.subjectName}}</span>
					<i></i>
				</div>
			</div>
		</div>
		<div class="group_r">
			<router-link :to="{ path: '/video', query: { id: item.id}}" v-for="(item,index) in groupCont" :key="index" class="group_list bg_white radius8">
				<img :src="item.pic" class="group_list_img radius8 block" />
				<div class="group_list_text">
					<div class="group_list_top flex">
						<h3 class="f18px clip">{{item.name}}</h3>
						<p class="cl_violet"><span>{{item.video_num}}节</span><i>全</i></p>
					</div>
					<div class="group_list_btm flex f16px cl_gray mat15">
						<p><img src="../../static/icon_video.png" /><span>{{item.browse_num}}</span></p>
						<!-- <p><img src="../../static/message.png" /><span>{{item.people}}</span></p> -->
					</div>
				</div>
			</router-link>
		</div>
	</div>
</template>

<script>
	export default {
	  name: 'course_group',
	  props: {
	    groupInfo: {
				type: Object,
				default: function () {
					return {
						
					}
				}
			},
			groupNav: {
				type: Array,
				default: function () {
					return []
				}
			},
			groupCurrent: Number,
			groupCont: {
				type: Array,
				default: function () {
					return []
				}
			}
	  },
		data () {
			return {
					
			}
		},
		methods: {
			navCheck (e) {
				this.$emit("child-event",e)
			},
		},
	}
</script>

<style>
</style>
